import React from "react";
import MySkill from "./Skill";
import Study from "./Study";
import Work from "./Work";
import "../style/style.css";
import "../responsive/mobile.css";

const MainContent = () => {
    return (
        <>
            <section className="first-screen content-width" id="home">
                <div className="say-hi">
                    <p className="hi-eyebrow">Welcome to my portfolio</p>
                    <h1>
                        Hello, I'm <span className="hi-name">Verak</span>
                    </h1>
                    <p className="hi-role">Software Engineer | ERP Engineer</p>
                    <p className="hi-tagline">
                        Designing scalable systems and ERP solutions that help organizations work more efficiently while delivering seamless user experiences.
                    </p>
                    <div className="hi-actions">
                        <a href="#work" className="hi-btn hi-btn-primary">
                            View my work
                        </a>
                        <a href="#study" className="hi-btn hi-btn-ghost">
                            My background
                        </a>
                    </div>
                </div>

                <div className="profile">
                    <div className="profile-ring" aria-hidden="true" />
                    <img
                        src="image/profile.jpg"
                        alt="Portrait of Verak"
                        className="vert-move profile-photo"
                    />
                </div>
            </section>

            <MySkill />
            <Study />
            <Work />
        </>
    );
};

export default MainContent;
